function initBunnyPlayer() {
    var players = document.querySelectorAll('[data-bunny-player-init]')
    console.log('[bunny] initBunnyPlayer players=', players.length)
    var nativePreferredSrcCache = {}

    // Shared idle timer (5 min) for autoplay players
    var idleManager =
        window.__bunnyIdleManager ||
        (window.__bunnyIdleManager = (function () {
            // var idleMs = 5 * 1 * 1000
            // var idleMs = 20 * 1000
            // var idleMs = 60 * 1000
            var idleMs = 5 * 60 * 1000
            var state = {
                timerId: null,
                idle: false,
                callbacks: [],
                activeCallbacks: []
            }

            function runCallbacks() {
                state.callbacks.forEach(function (fn) {
                    fn()
                })
            }
            function runActiveCallbacks() {
                state.activeCallbacks.forEach(function (fn) {
                    fn()
                })
            }
            function onIdle() {
                state.idle = true
                runCallbacks()
            }
            function resetTimer() {
                clearTimeout(state.timerId)
                state.timerId = setTimeout(onIdle, idleMs)
            }
            function onActivity() {
                if (state.idle) {
                    state.idle = false
                    runActiveCallbacks()
                }
                resetTimer()
            }

            var events = [
                'pointerdown',
                'pointermove',
                'keydown',
                'scroll',
                'touchstart'
            ]
            events.forEach(function (evt) {
                window.addEventListener(evt, onActivity, { passive: true })
            })
            document.addEventListener('visibilitychange', function () {
                if (!document.hidden) onActivity()
            })

            resetTimer()

            return {
                onIdle: function (fn) {
                    state.callbacks.push(fn)
                },
                onActive: function (fn) {
                    state.activeCallbacks.push(fn)
                }
            }
        })())

    players.forEach(function (player) {
            var src = player.getAttribute('data-player-src')
            if (!src) return

            var video = player.querySelector('video')
            if (!video) return

            try {
                video.pause()
            } catch (_) {}
            try {
                video.removeAttribute('src')
                video.load()
            } catch (_) {}

            // Attribute helpers
            function setStatus(s) {
                if (player.getAttribute('data-player-status') !== s) {
                    player.setAttribute('data-player-status', s)
                }
            }
            function setMutedState(v) {
                video.muted = !!v
                player.setAttribute(
                    'data-player-muted',
                    video.muted ? 'true' : 'false'
                )
            }
            function setFsAttr(v) {
                player.setAttribute(
                    'data-player-fullscreen',
                    v ? 'true' : 'false'
                )
            }
            function setActivated(v) {
                player.setAttribute(
                    'data-player-activated',
                    v ? 'true' : 'false'
                )
            }
            if (!player.hasAttribute('data-player-activated'))
                setActivated(false)

            // Elements
            var timeline = player.querySelector('[data-player-timeline]')
            var progressBar = player.querySelector('[data-player-progress]')
            var bufferedBar = player.querySelector('[data-player-buffered]')
            var handle = player.querySelector('[data-player-timeline-handle]')
            var timeDurationEls = player.querySelectorAll(
                '[data-player-time-duration]'
            )
            var timeProgressEls = player.querySelectorAll(
                '[data-player-time-progress]'
            )

            // Flags
            var updateSize = player.getAttribute('data-player-update-size') // "true" | "cover" | null
            var lazyMode = player.getAttribute('data-player-lazy') // "true" | "meta" | null
            var isLazyTrue = lazyMode === 'true'
            var isLazyMeta = lazyMode === 'meta'
            var autoplay =
                player.getAttribute('data-player-autoplay') === 'true'
            var initialMuted =
                player.getAttribute('data-player-muted') === 'true'

            // Used to suppress 'ready' flicker when user just pressed play in lazy modes
            var pendingPlay = false

            // Autoplay forces muted; IO will trigger "fake click"
            if (autoplay) {
                setMutedState(true)
                video.loop = true
            } else {
                setMutedState(initialMuted)
            }

            video.setAttribute('muted', '')
            video.setAttribute('playsinline', '')
            video.setAttribute('webkit-playsinline', '')
            video.playsInline = true
            if (typeof video.disableRemotePlayback !== 'undefined')
                video.disableRemotePlayback = true
            if (autoplay) video.autoplay = false

            var isSafariNative = !!video.canPlayType(
                'application/vnd.apple.mpegurl'
            )
            var canUseHlsJs =
                !!(window.Hls && Hls.isSupported()) && !isSafariNative
            console.log(
                '[bunny] player setup',
                src,
                'safariNative=',
                isSafariNative,
                'canUseHlsJs=',
                canUseHlsJs,
                'autoplay=',
                autoplay,
                'lazy=',
                lazyMode || 'none'
            )

            // Minimal ratio fetch when requested (and not already handled by lazy meta)
            if (updateSize === 'true' && !isLazyMeta) {
                if (isLazyTrue) {
                    // Do nothing: no fetch, no <video> touch when lazy=true
                } else {
                    var prev = video.preload
                    video.preload = 'metadata'
                    var onMeta2 = function () {
                        setBeforeRatio(
                            player,
                            updateSize,
                            video.videoWidth,
                            video.videoHeight
                        )
                        video.removeEventListener('loadedmetadata', onMeta2)
                        video.preload = prev || ''
                    }
                    video.addEventListener('loadedmetadata', onMeta2, {
                        once: true
                    })
                    video.src = src
                }
            }

            //  Lazy meta fetch (duration + aspect) without attaching playback
            function fetchMetaOnce() {
                getSourceMeta(src, canUseHlsJs).then(function (meta) {
                    if (meta.width && meta.height)
                        setBeforeRatio(
                            player,
                            updateSize,
                            meta.width,
                            meta.height
                        )
                    if (
                        timeDurationEls.length &&
                        isFinite(meta.duration) &&
                        meta.duration > 0
                    ) {
                        setText(timeDurationEls, formatTime(meta.duration))
                    }
                    readyIfIdle(player, pendingPlay)
                })
            }

            // Attach media only once (for actual playback)
            var isAttached = false
            var userInteracted = false
            var lastPauseBy = ''
            var followerParent = autoplay
                ? player.closest('[data-follower-item]')
                : null
            var hoverActive = !followerParent
            var debugLabel = src ? src.split('/').pop() : 'unknown-source'
            var startupBufferAttr = parseFloat(
                player.getAttribute('data-player-start-buffer-sec')
            )
            var startupBufferSec = isFinite(startupBufferAttr)
                ? Math.max(0, startupBufferAttr)
                : canUseHlsJs
                  ? 6
                  : 0
            var hasStartedPlayback = false
            var playRequestId = 0

            function cancelPendingStart() {
                playRequestId += 1
                pendingPlay = false
            }
            function playWithStartupBuffer() {
                var requestId = ++playRequestId
                var fallbackMs = 10000

                function playNow() {
                    if (requestId !== playRequestId) return
                    safePlay(video)
                }
                function hasEnoughBuffer() {
                    return (
                        video.readyState >= 4 ||
                        bufferedAhead(video) >= startupBufferSec
                    )
                }
                if (hasStartedPlayback || startupBufferSec <= 0) {
                    playNow()
                    return
                }
                if (hasEnoughBuffer()) {
                    playNow()
                    return
                }

                var fallbackId = null
                function cleanup() {
                    if (fallbackId) clearTimeout(fallbackId)
                    video.removeEventListener('progress', check)
                    video.removeEventListener('loadeddata', check)
                    video.removeEventListener('canplaythrough', check)
                    video.removeEventListener('waiting', check)
                }
                function check() {
                    if (requestId !== playRequestId || !pendingPlay) {
                        cleanup()
                        return
                    }
                    if (hasEnoughBuffer()) {
                        cleanup()
                        playNow()
                    }
                }

                video.addEventListener('progress', check)
                video.addEventListener('loadeddata', check)
                video.addEventListener('canplaythrough', check)
                video.addEventListener('waiting', check)
                fallbackId = setTimeout(function () {
                    if (requestId !== playRequestId || !pendingPlay) {
                        cleanup()
                        return
                    }
                    cleanup()
                    playNow()
                }, fallbackMs)
                check()
            }

            if (autoplay) {
                if (followerParent) {
                    followerParent.addEventListener('mouseenter', function () {
                        hoverActive = true
                        if (document.hidden) return
                        if ((isLazyTrue || isLazyMeta) && !isAttached)
                            attachMediaOnce()
                        if (video.paused || video.ended) {
                            lastPauseBy = ''
                            pendingPlay = true
                            setStatus('loading')
                            playWithStartupBuffer()
                        }
                    })
                    followerParent.addEventListener('mouseleave', function () {
                        hoverActive = false
                        if (pendingPlay) cancelPendingStart()
                        if (!video.paused && !video.ended) {
                            lastPauseBy = 'hover'
                            video.pause()
                            setStatus('paused')
                        }
                    })
                }
                function isInViewport(el) {
                    var r = el.getBoundingClientRect()
                    return (
                        r.bottom > 0 &&
                        r.right > 0 &&
                        r.top < (window.innerHeight || 0) &&
                        r.left < (window.innerWidth || 0)
                    )
                }

                idleManager.onIdle(function () {
                    if (pendingPlay) cancelPendingStart()
                    if (!video.paused && !video.ended) {
                        lastPauseBy = 'idle'
                        video.pause()
                        setStatus('paused')
                    }
                })
                idleManager.onActive(function () {
                    if (lastPauseBy !== 'idle') return
                    if (document.hidden) return
                    if (!video.paused || video.ended) return
                    if (followerParent && !hoverActive) return
                    if (!isInViewport(player)) return
                    lastPauseBy = ''
                    pendingPlay = true
                    setStatus('loading')
                    playWithStartupBuffer()
                })
            }
            function attachMediaOnce() {
                if (isAttached) return
                isAttached = true
                console.log('[bunny] attachMediaOnce', debugLabel)

                if (player._hls) {
                    try {
                        player._hls.destroy()
                    } catch (_) {}
                    player._hls = null
                }

                if (isSafariNative) {
                    console.log('[bunny] media path=safari-native', debugLabel)
                    video.preload =
                        isLazyTrue || isLazyMeta ? 'auto' : video.preload
                    getPreferredNativeSrc(src, nativePreferredSrcCache).then(
                        function (preferredSrc) {
                            if (preferredSrc && preferredSrc !== src) {
                                console.log(
                                    '[bunny] safari preferred rendition',
                                    debugLabel,
                                    preferredSrc
                                )
                            }
                            video.src = preferredSrc || src
                        }
                    )
                    video.addEventListener(
                        'loadedmetadata',
                        function () {
                            readyIfIdle(player, pendingPlay)
                            if (updateSize === 'true')
                                setBeforeRatio(
                                    player,
                                    updateSize,
                                    video.videoWidth,
                                    video.videoHeight
                                )
                            if (timeDurationEls.length)
                                setText(
                                    timeDurationEls,
                                    formatTime(video.duration)
                                )
                        },
                        { once: true }
                    )
                } else if (canUseHlsJs) {
                    console.log('[bunny] media path=hls.js', debugLabel)
                    var hls = new Hls({
                        maxBufferLength: 10,
                        autoStartLoad: false
                    })
                    var loggedFirstFrag = false
                    function logHlsQuality(tag, levelIndex) {
                        var levels = hls.levels || []
                        var lvl = levels[levelIndex]
                        if (!lvl) {
                            console.log(
                                '[bunny:hls]',
                                debugLabel,
                                tag,
                                'level=',
                                levelIndex
                            )
                            return
                        }
                        console.log(
                            '[bunny:hls]',
                            debugLabel,
                            tag,
                            'level=',
                            levelIndex,
                            'res=',
                            (lvl.width || '?') + 'x' + (lvl.height || '?'),
                            'bitrate=',
                            lvl.bitrate || '?'
                        )
                    }

                    hls.attachMedia(video)
                    hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                        hls.loadSource(src)
                    })
                    hls.on(Hls.Events.MANIFEST_PARSED, function (e, data) {
                        var lvlsForStart =
                            (data && data.levels) || hls.levels || []
                        console.log(
                            '[bunny:hls]',
                            debugLabel,
                            'manifest parsed, levels=',
                            lvlsForStart.length
                        )
                        var startLevel = bestLevelIndex(lvlsForStart)
                        if (startLevel >= 0) {
                            // Force a high initial quality for the first fragments.
                            hls.startLevel = startLevel
                            hls.loadLevel = startLevel
                            hls.currentLevel = startLevel
                            hls.nextLevel = startLevel
                            logHlsQuality('forced start', startLevel)
                        }
                        hls.startLoad(-1)

                        readyIfIdle(player, pendingPlay)
                        if (updateSize === 'true') {
                            var lvls = hls.levels || []
                            var best = bestLevel(lvls)
                            if (best && best.width && best.height)
                                setBeforeRatio(
                                    player,
                                    updateSize,
                                    best.width,
                                    best.height
                                )
                        }
                    })
                    hls.on(Hls.Events.LEVEL_LOADED, function (e, data) {
                        if (
                            data &&
                            data.details &&
                            isFinite(data.details.totalduration)
                        ) {
                            if (timeDurationEls.length)
                                setText(
                                    timeDurationEls,
                                    formatTime(data.details.totalduration)
                                )
                        }
                    })
                    hls.on(Hls.Events.LEVEL_SWITCHED, function (e, data) {
                        if (!data || !isFinite(data.level)) return
                        logHlsQuality('level switched', data.level)
                    })
                    hls.on(Hls.Events.FRAG_LOADED, function (e, data) {
                        if (loggedFirstFrag) return
                        if (!data || !isFinite(data.level)) return
                        loggedFirstFrag = true
                        logHlsQuality('first fragment loaded', data.level)
                    })
                    hls.on(Hls.Events.ERROR, function (e, data) {
                        console.warn(
                            '[bunny:hls]',
                            debugLabel,
                            'error',
                            data && data.type,
                            data && data.details,
                            'fatal=',
                            !!(data && data.fatal)
                        )
                    })
                    player._hls = hls
                } else {
                    console.log('[bunny] media path=plain-video', debugLabel)
                    video.src = src
                }
            }

            // Initialize based on lazy mode
            if (isLazyMeta) {
                fetchMetaOnce()
                video.preload = 'none'
            } else if (isLazyTrue) {
                video.preload = 'none'
            } else {
                attachMediaOnce()
            }

            // Toggle play/pause
            function togglePlay() {
                userInteracted = true
                if (video.paused || video.ended) {
                    if ((isLazyTrue || isLazyMeta) && !isAttached)
                        attachMediaOnce()
                    pendingPlay = true
                    lastPauseBy = ''
                    setStatus('loading')
                    playWithStartupBuffer()
                } else {
                    if (pendingPlay) cancelPendingStart()
                    lastPauseBy = 'manual'
                    video.pause()
                }
            }

            // Toggle mute
            function toggleMute() {
                video.muted = !video.muted
                player.setAttribute(
                    'data-player-muted',
                    video.muted ? 'true' : 'false'
                )
            }

            // Fullscreen helpers
            function isFsActive() {
                return !!(
                    document.fullscreenElement ||
                    document.webkitFullscreenElement
                )
            }
            function enterFullscreen() {
                if (player.requestFullscreen) return player.requestFullscreen()
                if (video.requestFullscreen) return video.requestFullscreen()
                if (
                    video.webkitSupportsFullscreen &&
                    typeof video.webkitEnterFullscreen === 'function'
                )
                    return video.webkitEnterFullscreen()
            }
            function exitFullscreen() {
                if (document.exitFullscreen) return document.exitFullscreen()
                if (document.webkitExitFullscreen)
                    return document.webkitExitFullscreen()
                if (
                    video.webkitDisplayingFullscreen &&
                    typeof video.webkitExitFullscreen === 'function'
                )
                    return video.webkitExitFullscreen()
            }
            function toggleFullscreen() {
                if (isFsActive() || video.webkitDisplayingFullscreen)
                    exitFullscreen()
                else enterFullscreen()
            }
            document.addEventListener('fullscreenchange', function () {
                setFsAttr(isFsActive())
            })
            document.addEventListener('webkitfullscreenchange', function () {
                setFsAttr(isFsActive())
            })
            video.addEventListener('webkitbeginfullscreen', function () {
                setFsAttr(true)
            })
            video.addEventListener('webkitendfullscreen', function () {
                setFsAttr(false)
            })

            // Controls (delegated)
            player.addEventListener('click', function (e) {
                var btn = e.target.closest('[data-player-control]')
                if (!btn || !player.contains(btn)) return
                var type = btn.getAttribute('data-player-control')
                if (type === 'play' || type === 'pause' || type === 'playpause')
                    togglePlay()
                else if (type === 'mute') toggleMute()
                else if (type === 'fullscreen') toggleFullscreen()
            })

            // Time text (not in rAF)
            function updateTimeTexts() {
                if (timeDurationEls.length)
                    setText(timeDurationEls, formatTime(video.duration))
                if (timeProgressEls.length)
                    setText(timeProgressEls, formatTime(video.currentTime))
            }
            video.addEventListener('timeupdate', updateTimeTexts)
            video.addEventListener('loadedmetadata', function () {
                updateTimeTexts()
                maybeSetRatioFromVideo(player, updateSize, video)
            })
            video.addEventListener('loadeddata', function () {
                maybeSetRatioFromVideo(player, updateSize, video)
            })
            video.addEventListener('playing', function () {
                maybeSetRatioFromVideo(player, updateSize, video)
            })
            video.addEventListener('durationchange', updateTimeTexts)

            // rAF visuals (progress + handle only)
            var rafId
            function updateProgressVisuals() {
                if (!video.duration) return
                var playedPct = (video.currentTime / video.duration) * 100
                if (progressBar)
                    progressBar.style.transform =
                        'translateX(' + (-100 + playedPct) + '%)'
                if (handle) handle.style.left = playedPct + '%'
            }
            function loop() {
                updateProgressVisuals()
                if (!video.paused && !video.ended)
                    rafId = requestAnimationFrame(loop)
            }

            // Buffered bar (not in rAF)
            function updateBufferedBar() {
                if (!bufferedBar || !video.duration || !video.buffered.length)
                    return
                var end = video.buffered.end(video.buffered.length - 1)
                var buffPct = (end / video.duration) * 100
                bufferedBar.style.transform =
                    'translateX(' + (-100 + buffPct) + '%)'
            }
            video.addEventListener('progress', updateBufferedBar)
            video.addEventListener('loadedmetadata', updateBufferedBar)
            video.addEventListener('durationchange', updateBufferedBar)

            // Media event wiring
            video.addEventListener('play', function () {
                setActivated(true)
                cancelAnimationFrame(rafId)
                loop()
                setStatus('playing')
            })
            video.addEventListener('playing', function () {
                hasStartedPlayback = true
                pendingPlay = false
                setStatus('playing')
            })
            video.addEventListener('pause', function () {
                pendingPlay = false
                cancelAnimationFrame(rafId)
                updateProgressVisuals()
                setStatus('paused')
            })
            video.addEventListener('waiting', function () {
                setStatus('loading')
            })
            video.addEventListener('canplay', function () {
                readyIfIdle(player, pendingPlay)
            })
            video.addEventListener('ended', function () {
                pendingPlay = false
                cancelAnimationFrame(rafId)
                updateProgressVisuals()
                setStatus('paused')
                setActivated(false)
            })

            // Scrubbing (pointer events)
            if (timeline) {
                var dragging = false,
                    wasPlaying = false,
                    targetTime = 0,
                    lastSeekTs = 0,
                    seekThrottle = 180,
                    rect = null
                window.addEventListener('resize', function () {
                    if (!dragging) rect = null
                })
                function getFractionFromX(x) {
                    if (!rect) rect = timeline.getBoundingClientRect()
                    var f = (x - rect.left) / rect.width
                    if (f < 0) f = 0
                    if (f > 1) f = 1
                    return f
                }
                function previewAtFraction(f) {
                    if (!video.duration) return
                    var pct = f * 100
                    if (progressBar)
                        progressBar.style.transform =
                            'translateX(' + (-100 + pct) + '%)'
                    if (handle) handle.style.left = pct + '%'
                    if (timeProgressEls.length)
                        setText(timeProgressEls, formatTime(f * video.duration))
                }
                function maybeSeek(now) {
                    if (!video.duration) return
                    if (now - lastSeekTs < seekThrottle) return
                    lastSeekTs = now
                    video.currentTime = targetTime
                }
                function onPointerDown(e) {
                    if (!video.duration) return
                    dragging = true
                    wasPlaying = !video.paused && !video.ended
                    if (wasPlaying) video.pause()
                    player.setAttribute('data-timeline-drag', 'true')
                    rect = timeline.getBoundingClientRect()
                    var f = getFractionFromX(e.clientX)
                    targetTime = f * video.duration
                    previewAtFraction(f)
                    maybeSeek(performance.now())
                    timeline.setPointerCapture &&
                        timeline.setPointerCapture(e.pointerId)
                    window.addEventListener('pointermove', onPointerMove, {
                        passive: false
                    })
                    window.addEventListener('pointerup', onPointerUp, {
                        passive: true
                    })
                    e.preventDefault()
                }
                function onPointerMove(e) {
                    if (!dragging) return
                    var f = getFractionFromX(e.clientX)
                    targetTime = f * video.duration
                    previewAtFraction(f)
                    maybeSeek(performance.now())
                    e.preventDefault()
                }
                function onPointerUp() {
                    if (!dragging) return
                    dragging = false
                    player.setAttribute('data-timeline-drag', 'false')
                    rect = null
                    video.currentTime = targetTime
                    if (wasPlaying) playWithStartupBuffer()
                    else {
                        updateProgressVisuals()
                        updateTimeTexts()
                    }
                    window.removeEventListener('pointermove', onPointerMove)
                    window.removeEventListener('pointerup', onPointerUp)
                }
                timeline.addEventListener('pointerdown', onPointerDown, {
                    passive: false
                })
                if (handle)
                    handle.addEventListener('pointerdown', onPointerDown, {
                        passive: false
                    })
            }

            // Hover/idle detection (pointer-based)
            var hoverTimer
            var hoverHideDelay = 1500
            function setHover(state) {
                if (player.getAttribute('data-player-hover') !== state) {
                    player.setAttribute('data-player-hover', state)
                }
            }
            function scheduleHide() {
                clearTimeout(hoverTimer)
                hoverTimer = setTimeout(function () {
                    setHover('idle')
                }, hoverHideDelay)
            }
            function wakeControls() {
                setHover('active')
                scheduleHide()
            }
            player.addEventListener('pointerdown', wakeControls)
            document.addEventListener('fullscreenchange', wakeControls)
            document.addEventListener('webkitfullscreenchange', wakeControls)
            var trackingMove = false
            function onPointerMoveGlobal(e) {
                var r = player.getBoundingClientRect()
                // if (
                //     e.clientX >= r.left &&
                //     e.clientX <= r.right &&
                //     e.clientY >= r.top &&
                //     e.clientY <= r.bottom
                // )
                //     wakeControls()
            }
            player.addEventListener('pointerenter', function () {
                // wakeControls()
                if (!trackingMove) {
                    trackingMove = true
                    window.addEventListener(
                        'pointermove',
                        onPointerMoveGlobal,
                        { passive: true }
                    )
                }
            })
            player.addEventListener('pointerleave', function () {
                setHover('idle')
                clearTimeout(hoverTimer)
                if (trackingMove) {
                    trackingMove = false
                    window.removeEventListener(
                        'pointermove',
                        onPointerMoveGlobal
                    )
                }
            })

            // In-view auto play/pause (only when autoplay is true)
            if (autoplay) {
                var io = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            var inView =
                                entry.isIntersecting &&
                                entry.intersectionRatio > 0

                            if (inView) {
                                if (followerParent && !hoverActive) return
                                if ((isLazyTrue || isLazyMeta) && !isAttached)
                                    attachMediaOnce()

                                if (video.paused) {
                                    // we will attempt to play -> show loading until events flip to playing
                                    lastPauseBy = ''
                                    pendingPlay = true
                                    setStatus('loading')
                                    playWithStartupBuffer()
                                } else {
                                    // already playing; don't flash loading
                                    setStatus('playing')
                                }
                            } else {
                                if (pendingPlay) {
                                    cancelPendingStart()
                                    setStatus('paused')
                                }
                                if (!video.paused && !video.ended) {
                                    lastPauseBy = 'io'
                                    video.pause()
                                    setStatus('paused') // keep UI honest while out of view
                                }
                            }
                        })
                    },
                    { threshold: 0.1 }
                )

                io.observe(player)
            }
        })

    // Helper: time/text/meta/ratio utilities
    function pad2(n) {
        return (n < 10 ? '0' : '') + n
    }
    function formatTime(sec) {
        if (!isFinite(sec) || sec < 0) return '00:00'
        var s = Math.floor(sec),
            h = Math.floor(s / 3600),
            m = Math.floor((s % 3600) / 60),
            r = s % 60
        return h > 0
            ? h + ':' + pad2(m) + ':' + pad2(r)
            : pad2(m) + ':' + pad2(r)
    }
    function setText(nodes, text) {
        nodes.forEach(function (n) {
            n.textContent = text
        })
    }

    // Helper: Choose best HLS level by resolution --- */
    function bestLevel(levels) {
        if (!levels || !levels.length) return null
        return levels.reduce(function (a, b) {
            return (b.width || 0) > (a.width || 0) ? b : a
        }, levels[0])
    }
    function bestLevelIndex(levels) {
        if (!levels || !levels.length) return -1
        return levels.reduce(function (bestIdx, level, idx, arr) {
            var best = arr[bestIdx] || {}
            var levelW = level.width || 0
            var bestW = best.width || 0
            if (levelW !== bestW) return levelW > bestW ? idx : bestIdx

            var levelBitrate = level.bitrate || 0
            var bestBitrate = best.bitrate || 0
            return levelBitrate > bestBitrate ? idx : bestIdx
        }, 0)
    }

    // Helper: Safe programmatic play
    function safePlay(video) {
        var p = video.play()
        if (p && typeof p.then === 'function') p.catch(function () {})
    }
    function bufferedAhead(video) {
        if (!video || !video.buffered || !video.buffered.length) return 0
        var t = video.currentTime || 0
        for (var i = 0; i < video.buffered.length; i++) {
            var s = video.buffered.start(i)
            var e = video.buffered.end(i)
            if (t >= s && t <= e) return Math.max(0, e - t)
        }
        var firstStart = video.buffered.start(0)
        var firstEnd = video.buffered.end(0)
        if (t < firstStart) return Math.max(0, firstEnd - firstStart)
        return 0
    }

    // Helper: Ready status guard
    function readyIfIdle(player, pendingPlay) {
        if (
            !pendingPlay &&
            player.getAttribute('data-player-activated') !== 'true' &&
            player.getAttribute('data-player-status') === 'idle'
        ) {
            player.setAttribute('data-player-status', 'ready')
        }
    }

    // Helper: Ratio Setter
    function setBeforeRatio(player, updateSize, w, h) {
        if (updateSize !== 'true' || !w || !h) return
        var before = player.querySelector('[data-player-before]')
        if (!before) return
        before.style.paddingTop = (h / w) * 100 + '%'
    }
    function maybeSetRatioFromVideo(player, updateSize, video) {
        if (updateSize !== 'true') return
        var before = player.querySelector('[data-player-before]')
        if (!before) return
        var hasPad = before.style.paddingTop && before.style.paddingTop !== '0%'
        if (!hasPad && video.videoWidth && video.videoHeight) {
            setBeforeRatio(
                player,
                updateSize,
                video.videoWidth,
                video.videoHeight
            )
        }
    }

    // Helper: simple URL resolver
    function resolveUrl(base, rel) {
        try {
            return new URL(rel, base).toString()
        } catch (_) {
            return rel
        }
    }
    function getPreferredNativeSrc(src, cache) {
        if (!src || src.indexOf('.m3u8') === -1) return Promise.resolve(src)
        if (!cache[src]) {
            cache[src] = fetch(src, { credentials: 'omit', cache: 'no-store' })
                .then(function (r) {
                    if (!r.ok) throw new Error('master')
                    return r.text()
                })
                .then(function (masterText) {
                    return chooseBestVariantUrl(src, masterText) || src
                })
                .catch(function () {
                    return src
                })
        }
        return cache[src]
    }
    function chooseBestVariantUrl(masterUrl, masterText) {
        if (!masterText || masterText.indexOf('#EXT-X-STREAM-INF:') === -1)
            return null

        var lines = masterText.split(/\r?\n/)
        var best = null
        var lastInf = null

        for (var i = 0; i < lines.length; i++) {
            var line = (lines[i] || '').trim()
            if (!line) continue
            if (line.indexOf('#EXT-X-STREAM-INF:') === 0) {
                lastInf = line
                continue
            }
            if (!lastInf || line[0] === '#') continue

            var rel = line
            var bwMatch = /(?:^|,)BANDWIDTH=(\d+)/.exec(lastInf)
            var avgMatch = /(?:^|,)AVERAGE-BANDWIDTH=(\d+)/.exec(lastInf)
            var resMatch = /(?:^|,)RESOLUTION=(\d+)x(\d+)/.exec(lastInf)
            var bw = avgMatch
                ? parseInt(avgMatch[1], 10)
                : bwMatch
                  ? parseInt(bwMatch[1], 10)
                  : 0
            var w = resMatch ? parseInt(resMatch[1], 10) : 0
            var h = resMatch ? parseInt(resMatch[2], 10) : 0
            var area = w * h

            var candidate = {
                rel: rel,
                bw: isFinite(bw) ? bw : 0,
                area: isFinite(area) ? area : 0,
                w: w,
                h: h
            }

            if (!best) {
                best = candidate
            } else if (candidate.bw > best.bw) {
                best = candidate
            } else if (candidate.bw === best.bw && candidate.area > best.area) {
                best = candidate
            }

            lastInf = null
        }

        return best ? resolveUrl(masterUrl, best.rel) : null
    }

    // Helper: Unified meta fetch (hls.js or native fetch)
    function getSourceMeta(src, useHlsJs) {
        return new Promise(function (resolve) {
            if (useHlsJs && window.Hls && Hls.isSupported()) {
                try {
                    var tmp = new Hls()
                    var out = { width: 0, height: 0, duration: NaN }
                    var haveLvls = false,
                        haveDur = false

                    tmp.on(Hls.Events.MANIFEST_PARSED, function (e, data) {
                        var lvls = (data && data.levels) || tmp.levels || []
                        var best = bestLevel(lvls)
                        if (best && best.width && best.height) {
                            out.width = best.width
                            out.height = best.height
                            haveLvls = true
                        }
                    })
                    tmp.on(Hls.Events.LEVEL_LOADED, function (e, data) {
                        if (
                            data &&
                            data.details &&
                            isFinite(data.details.totalduration)
                        ) {
                            out.duration = data.details.totalduration
                            haveDur = true
                        }
                    })
                    tmp.on(Hls.Events.ERROR, function () {
                        try {
                            tmp.destroy()
                        } catch (_) {}
                        resolve(out)
                    })
                    tmp.on(Hls.Events.LEVEL_LOADED, function () {
                        try {
                            tmp.destroy()
                        } catch (_) {}
                        resolve(out)
                    })

                    tmp.loadSource(src)
                    return
                } catch (_) {
                    resolve({ width: 0, height: 0, duration: NaN })
                    return
                }
            }

            function parseMaster(masterText) {
                var lines = masterText.split(/\r?\n/)
                var bestW = 0,
                    bestH = 0,
                    firstMedia = null,
                    lastInf = null
                for (var i = 0; i < lines.length; i++) {
                    var line = lines[i]
                    if (line.indexOf('#EXT-X-STREAM-INF:') === 0) {
                        lastInf = line
                    } else if (lastInf && line && line[0] !== '#') {
                        if (!firstMedia) firstMedia = line.trim()
                        var m = /RESOLUTION=(\d+)x(\d+)/.exec(lastInf)
                        if (m) {
                            var w = parseInt(m[1], 10),
                                h = parseInt(m[2], 10)
                            if (w > bestW) {
                                bestW = w
                                bestH = h
                            }
                        }
                        lastInf = null
                    }
                }
                return { bestW: bestW, bestH: bestH, media: firstMedia }
            }
            function sumDuration(mediaText) {
                var dur = 0,
                    re = /#EXTINF:([\d.]+)/g,
                    m
                while ((m = re.exec(mediaText))) dur += parseFloat(m[1])
                return dur
            }

            fetch(src, { credentials: 'omit', cache: 'no-store' })
                .then(function (r) {
                    if (!r.ok) throw new Error('master')
                    return r.text()
                })
                .then(function (master) {
                    var info = parseMaster(master)
                    if (!info.media) {
                        resolve({
                            width: info.bestW || 0,
                            height: info.bestH || 0,
                            duration: NaN
                        })
                        return
                    }
                    var mediaUrl = resolveUrl(src, info.media)
                    return fetch(mediaUrl, {
                        credentials: 'omit',
                        cache: 'no-store'
                    })
                        .then(function (r) {
                            if (!r.ok) throw new Error('media')
                            return r.text()
                        })
                        .then(function (mediaText) {
                            resolve({
                                width: info.bestW || 0,
                                height: info.bestH || 0,
                                duration: sumDuration(mediaText)
                            })
                        })
                })
                .catch(function () {
                    resolve({ width: 0, height: 0, duration: NaN })
                })
        })
    }
}

// Initialize Bunny HTML HLS Player (Advanced)
document.addEventListener('DOMContentLoaded', function () {
    initBunnyPlayer()
})
